import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { map } from 'rxjs/operators';
import { first, tap } from 'rxjs';
import { getQuickRenewExecutionData } from '@aaa/emember/store-quick-renew';
import { Pages } from '../../../constants/pages';

export const checkPayment: CanActivateChildFn = () => {
  const router = inject(Router);
  const store = inject(Store<AppStore>);

  return store.select(getQuickRenewExecutionData).pipe(
    first(),
    map((executionData) => !!executionData),
    tap((executionData) => !executionData && router.navigateByUrl(Pages.renew)),
  );
};

export default checkPayment;
